import { getQingzhouConfig } from "@/services";
import reporter from "@/tracker/report/reporter";
import { getPage } from "@/tracker/shared/global";
import useLaunchBottomVisibility from "@/utils/hooks/useLaunchBottomVisibility";
import {
  SuspensionPanel,
  offTrackerClickEventListener,
  onTrackerClickEventListener,
} from "@gdesign/suspension-panel";
import "@gdesign/suspension-panel/style.css";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { openUdesk } from "../../../utils/initUdesk";
import styles from "./index.module.less";

export default function SuspensionPanelComponent() {
  const { launchBottomVisible } = useLaunchBottomVisibility();
  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    let isMounted = true;
    getQingzhouConfig({
      position: "framework-suspension-panel-huaban",
    }).then((res) => {
      if (isMounted) {
        setDataSource(res);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const trackerClickEventListener = (data) => {
      const pageName = getPage();
      const trackData = {
        event_id: 39008,
        event_name: "button_click",
        module_name: "右侧悬浮导航",
        subject_name: "按钮",
        button_name: data.detail.button_name,
        ...pageName,
      };
      reporter(trackData);
    };

    onTrackerClickEventListener(trackerClickEventListener);

    return () => {
      offTrackerClickEventListener(trackerClickEventListener);
    };
  }, []);

  return (
    <div
      className={classNames([
        styles.suspensionPanel,
        launchBottomVisible ? styles.launchBottomShow : null,
      ])}
    >
      <SuspensionPanel
        portal="huaban"
        dataSource={{
          pits: dataSource?.pits || [],
        }}
        onCustomerServiceClick={openUdesk}
      />
    </div>
  );
}
